function setPageSize(el){
    var url = document.location.href;
    var pageSize = el.value;
    if (url.includes('pagesize=')){
        url = url.replace(/pagesize=\d+/g, 'pagesize=' + pageSize);
    } else {
        url = url + '?pagesize=' + pageSize;
    }
    window.location.href = url;
}


function setParametersInPaginationButtons(){      
    pagniationButtonsContainer = document.getElementById('collection-pages');
    paginationButtons = pagniationButtonsContainer.querySelectorAll(".page");
    paginationNextOrPreviouseButtons = pagniationButtonsContainer.querySelectorAll(".next, .previous");

    paginationButtons.forEach((button) => {
            hyperlink = button.querySelector('a');
            if (hyperlink &&  !hyperlink.href.includes('pagesize=')) {
                    href = hyperlink.href.split('?')[0] + '?pagesize={{pageSize}}' + '&' + hyperlink.href.split('?')[1];
                    hyperlink.href = href
            }
    });
    paginationNextOrPreviouseButtons.forEach((button) => {
            hyperlink = button.querySelector('a');
            if (hyperlink &&  !hyperlink.href.includes('pagesize=')) {
                    href = hyperlink.href.split('?')[0] + '?pagesize={{pageSize}}' + '&' + hyperlink.href.split('?')[1];
                    hyperlink.href = href
            }
    });
}

function parseRichText(node) {

    if (node.nodeType === 'text') {
        let text = node.value;
        if (node.marks) {
            node.marks.forEach(mark => {
                if (mark.type === 'bold') {
                    text = `<strong>${text}</strong>`;
                }
                if (mark.type === 'italic') {
                    text = `<em>${text}</em>`;
                }
                if (mark.type === 'underline') {
                    text = `<u>${text}</u>`;
                }

            });
        }
        return text;

        } else if (node.nodeType === 'hyperlink') {
            return `<a title="${node.content.map(parseRichText)}" href="${node.data.uri}">${node.content.map(parseRichText).join('')}</a>`;
        } else if (node.nodeType === 'paragraph') {
            return `<p>${node.content.map(parseRichText).join('')}</p>`;
        } else if (node.nodeType === 'document') {
            return node.content.map(parseRichText).join('');
        }
    return '';
    }

function getContentfulCollection(){
    console.log(collectionHandle);
    const spaceId = 'r8ntwc7p992u';
    const accessToken = 'C_-9V7wqzxMRbmSgfL-8CKh5-MUboq-YQ2UOmB3WHnU';

    const contentful = `https://cdn.contentful.com/spaces/${spaceId}/entries?content_type=collectionHeader&fields.collectionSlug[in]=${collectionHandle}`;
    const headers = {
    Authorization: `Bearer ${accessToken}`
    };

    fetch(contentful, { headers })
    .then(response => response.json())
    .then(data => {
        const title = data.items[0].fields.collectionTitle;
        const subtitle = data.items[0].fields.collectionSubTitle;


            fillTitleText(title, '#collection_title');
            fillSubtitleText(subtitle, '#collection_description');
            parseDescription(data);
    })
    .catch(error => {
        console.error('Likely No Data:', error);
    });

    }

function parseDescription(data){
    if(data.items[0].fields.collectionDescriptionLeftSection.content !== '' && data.items[0].fields.collectionDescriptionLeftSection.content !== undefined){
        var contentNodes = data.items[0].fields.collectionDescriptionLeftSection.content;
        var parsedHtml = '';
        contentNodes.forEach(node => {
            parsedHtml += parseRichText(node);
        });
        fillDescriptionText(parsedHtml, "#collection_description_left");
    }
    if(data.items[0].fields.collectionDescriptionRightSection !== undefined){
        var contentNodes = data.items[0].fields.collectionDescriptionRightSection.content;
        var parsedHtml = '';
        contentNodes.forEach(node => {
            parsedHtml += parseRichText(node);
        });
        fillDescriptionText(parsedHtml, "#collection_description_right");
    }
    if( data.items[0].fields.collectionDescription !== undefined){
        var contentNodes = data.items[0].fields.collectionDescription.content;
        var parsedHtml = '';
        contentNodes.forEach(node => {
            parsedHtml += parseRichText(node);
        });
        fillDescriptionText(parsedHtml, "#collection_description");
    }
    if (data.includes && data.includes.Asset && data.includes.Asset[0] !== undefined){
        var image = data.includes.Asset[0];
        var imageURL = image.fields.file.url.replace('//', 'https://');
        var imageDescription = image.fields.description;
        var imageTitle = image.fields.title;
        var image = document.createElement('img');
        image.src = imageURL;
        image.alt = imageDescription;
        image.title = imageTitle;
        image.setAttribute('width', '149px');
        image.setAttribute('height', '149px');
        image.classList.add('collectionImage');
        var imageContainer = document.getElementById('collection_split_image');
        imageContainer.appendChild(image);
    }
}

function fillTitleText(data, titleContainer){
    titleContainer = document.querySelector(titleContainer);
    titleContainer.innerHTML = data;
    }

  function fillSubtitleText(data){
    subtitleContainer = document.querySelector('#collection_subtitle');
    subtitleContainer.innerHTML = data;
  }
  function fillDescriptionText(data, descriptionContainer){
    descriptionContainer = document.querySelector(descriptionContainer);
    descriptionContainer.innerHTML = data;
  }
getContentfulCollection();





// filter


setTimeout(function(){
    for (var key in brandCount) {
        var value = brandCount[key];
        var label = document.getElementById(key + '-BF-label');
        if (label){
            var currentText = label.textContent;
            label.innerHTML = currentText + " <span class='filterCount'>(" + value + ")</span>";
        }

    }
    for (var key in formatCount){
        var value = formatCount[key];
        document.getElementById(key + '-format-label').innerHTML += " <span class='filterCount'>(" + value + ")</span>";
        
    }
    for (var key in cpu_familyCount) {
        try{
        var value = cpu_familyCount[key];
        document.getElementById(key + '-family-checkbox').innerHTML += " <span class='filterCount'>(" + value + ")</span>";
        } catch (e) {
            console.log(e);
        }
    }
    for (var key in bayCount) {
        try{
        var value = bayCount[key];
        document.getElementById(key.replace(' Bays', 'b') + '-numberofbays-label').innerHTML += " <span class='filterCount'>(" + value + ")</span>";
        } catch (e) {
            console.log(e);
        }
    }
    for (var key in formFactorCount) {
        try{
        var value = formFactorCount[key];
        document.getElementById(key + '-ru-label').innerHTML += " <span class='filterCount'>(" + value + ")</span>";
        } catch (e) {
            console.log(e);
        }
    }

    for (var key in nvmeCapable) {
        try{
        var value = nvmeCapable[key];
        document.getElementById("nvme-checkbox-label").innerHTML += " <span class='filterCount'>(" + value + ")</span>";
        } catch (e) {
            console.log(e);
        }
    }
    for (var key in baysizeCount) {
        try{
        var value = baysizeCount[key];
        document.getElementById(key + '-checkbox-label').innerHTML += " <span class='filterCount'>(" + value + ")</span>";
        } catch (e) {
            console.log(e);
        } 
    }
    for (var key in no_cpuCount) {
        var value = no_cpuCount[key];
        document.getElementById(key + '-cpu-checkbox').innerHTML += " <span class='filterCount'>(" + value + ")</span>";
    }

    var filterSelects = document.getElementsByClassName('brandFilter');

    for (var i = 0; i < filterSelects.length; i++) {
        var filterSelect = filterSelects[i];
        var input = filterSelect.children[0];
        var label = filterSelect.children[1];
        if (!filteredTags.includes(input.value)) {
        //    input.setAttribute('disabled', 'true');
            label.style.opacity = '0.5';

        }
    }
    
}, 100);

    window.addEventListener('DOMContentLoaded', (event) => {
        fetchStartingPrices()

        if (localStorage.getItem("ctoMinPrices") == null || localStorage.getItem("ctoMinPricesDate") == null || (new Date() - new Date(localStorage.getItem("ctoMinPricesDate"))) > 864000){
            fetchStartingPrices()
        } else {
            prices = JSON.parse(localStorage.getItem('ctoMinPrices'));
            for (const item in prices){
                    var id ;
                    if (prices[item]['sku'] !== 'null'){
                        id = prices[item]['sku'];
                    }
                   // setStartingPrice(prices[item]['price'], id);
                }
            }
        setTimeout(function(){
        var pageURL = window.location.href;
        var idsofTags = {"LFF" : "LFF-checkbox", "SFF" : "SFF-checkbox", "true" : "nvme-checkbox"};
        var collectionFilter = document.getElementById('filterInterior');
        var children = collectionFilter.children;
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            var childChildren = child.children;
            for (var j = 0; j < childChildren.length; j++) {
                var childChild = childChildren[j];
                if (childChild.tagName === 'SPAN') {
                    var input = childChild.children[0];
                    if (input && input.value){
                    idsofTags[input.value] = input.id;
                    } else {
                        console.log('No id found for ' + input);
                    }
                    }
                }
            }
        
        for (var i = 0; i < tags.length; i++) {
            if (pageURL.includes("=" + tags[i])) {
                var id = idsofTags[tags[i]];
                if (id && document.getElementById(id)){
                    var input = document.getElementById(id);
                } else {
                    if (isNaN(tags[i])){
                        console.log('No id found for ' + tags[i]);

                        var input = document.querySelector('.' + tags[i] + '-cb');
                    }
                }
                input.checked = true;
            }
        }
        } , 50);
    });


    function createProductCard(product, collection){
        if (product.title !== undefined && product.handle !== undefined && product.firstImage !== undefined){
            let productHandleUnderScore = product.handle.replace(/-/g, '_');

            let productCard = document.createElement('a');
            productCard.setAttribute('style', 'max-height:500px;');
            productCard.setAttribute('title', product.title);
            productCard.setAttribute('href', `/collections/${collection.handle}/products/${product.handle}`);
            


            let productContainer = document.createElement('div');
            productContainer.setAttribute('id', 'md-chass-container');
            productContainer.setAttribute('class', 'mcc-item loading-skeleton');

            
            let productImage = document.createElement('img');
            productImage.setAttribute('id', 'md-Chass-image');
            productImage.setAttribute('class', 'mp-img mcc-image lazyload');
            productImage.setAttribute('fetchpriority', 'high');
            productImage.setAttribute('loading', 'eager');
            productImage.setAttribute('srcset', product.srcSet);
            productImage.sizes="(max-width: 480px) 159px, (max-width: 800px) 318px, (max-width: 1200px) 480px";
            productImage.setAttribute('width', '480');  
            productImage.setAttribute('height', '480');
            productImage.setAttribute('data-first-src', product.firstImage);
            productImage.setAttribute('alt', product.imageAlt);
            productImage.setAttribute('data-second-src', product.secondImagePreview);
            productImage.setAttribute('data-second-full-src', product.secondImage);
            productImage.setAttribute('onmouseover', 'loadFullImage(this)');
            productImage.setAttribute('onmouseout', 'swapToOgImage(this)');

            let titleContainer = document.createElement('div');
            titleContainer.setAttribute('id', 'SkeletonPlaceholder');
            titleContainer.setAttribute('class', 'skeleton_text mdText');

            let productTitle = document.createElement('p');
            productTitle.setAttribute('id', 'md-Chass-title');
            productTitle.setAttribute('class', 'md-chass-title fullTitle');
            productTitle.innerHTML = product.title;

            let productPrice = document.createElement('p');
            productPrice.setAttribute('id', 'md-Chass-Price');
            productPrice.setAttribute('class', 'mcc-price ');
            productPrice.classList.add(`price-${productHandleUnderScore}`);
            
            let prodPrice = parseFloat(product.price.replace(/[^0-9.]/g, ""));
            if (isNaN(prodPrice)) {
                prodPrice = product.price.replaceAll("$","").replaceAll(",","");
            }
            let swDiscount = localStorage.getItem("eppSiteDiscount");

            if (localStorage.getItem("eppPartner") !== null && localStorage.getItem("eppSiteDiscount") !== null){
                if (product.epp !== ''){
                    if (product.epp === localStorage.getItem("eppPartner")){
                        swDiscount = localStorage.getItem("eppPartnerDiscount");
                    }
                }
                prodPrice = (prodPrice * 100) * (1 - (swDiscount / 100));
                prodPrice = prodPrice / 100;
                //if (isNaN(prodPrice)) prodPrice = product.price;
            }

            productPrice.innerHTML = `$${prodPrice.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
            
            if (localStorage.getItem("eppPartner") !== null && localStorage.getItem("eppSiteDiscount") !== null){
                if (swDiscount && parseInt(swDiscount) !== 0) productPrice.innerHTML = productPrice.innerHTML + ` (-${swDiscount}%)`;
            } 
                 


            //Starting at:
            let configureButton = document.createElement('div');
            configureButton.setAttribute('id', 'md-Chass-Configure-button');
            configureButton.setAttribute('class', 'mcc-configure-button');
            configureButton.innerHTML = `<svg class="md-chass-configure-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff">
                <path d="m620-284 56-56q6-6 6-14t-6-14L540-505q4-11 6-22t2-25q0-57-40.5-97.5T410-690q-17 0-34 4.5T343-673l94 94-56 56-94-94q-8 16-12.5 33t-4.5 34q0 57 40.5 97.5T408-412q13 0 24.5-2t22.5-6l137 136q6 6 14 6t14-6ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
                </svg>Configure`;

            productCard.appendChild(productContainer);
            productContainer.appendChild(productImage);
            productContainer.appendChild(titleContainer);

            titleContainer.appendChild(productTitle);
            productContainer.appendChild(productPrice);
            productContainer.appendChild(configureButton);

            return productCard;
        }
    }
    try{
        document.getElementById("products-of-collection-container").appendChild(createProductCard(product, collection));
    } catch (error){

    }      
function resetCTOFilters(hard=false){
    if (hard === true){
        localStorage.removeItem('productsOnPage');
        window.location.reload();
    }
    document.querySelectorAll('.brandFilter input:checked').forEach(filter => {
        filter.checked = false;
        filter.dispatchEvent(new Event('change'));
        
    });
    document.querySelectorAll('.brandFilter').forEach(filter => {
        filter.style.opacity = '1';
    });

    createProducts(JSON.parse(localStorage.getItem('productsOnPage')), 20, 0);
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
        });
}

let animationTimer;

function animateCount(start, end, element) {
    clearInterval(animationTimer);

    let duration = 314;
    if (end < 10) {
        duration = 131.4;
    }
    const range = end - start;
    const increment = range / (duration / 10);
    let current = start;

    animationTimer = setInterval(() => {
        element.style.color = '#0095ff';
        current += increment;
        element.textContent = Math.floor(current);
        if ((increment > 0 && current >= end) || (increment < 0 && current <= end)) {
            element.textContent = end;

            clearInterval(animationTimer);
            setTimeout(() => {
                element.style.color = '#3d4246';
            }, 300);
        }
    }, 10);
}

function createProductCountButtons(products) {
    const filterAnchor = document.querySelector('#collection-filter-anchor');
    const filterBubbleContainer = document.querySelector('.filterBubbleContainer');

    if (!document.querySelector('#prodCountContainer')) {
        const prodCountContainer = document.createElement('div');
        prodCountContainer.setAttribute('id', 'prodCountContainer');
        prodCountContainer.setAttribute('class', 'prodCountContainer');
        if (window.innerWidth > 768) {
            filterBubbleContainer.insertBefore(prodCountContainer, filterBubbleContainer.firstChild);
            document.querySelector("#sort-by").style.marginLeft = '3.14%';
        } else {
            prodCountContainer.style.justifyContent = 'center';
            prodCountContainer.style.marginLeft = '0px';
            prodCountContainer.style.marginRight = '0px';
            const collectionFilterAnchor = document.querySelector('#collection-filter-anchor');
            collectionFilterAnchor.parentNode.insertBefore(prodCountContainer, collectionFilterAnchor.nextSibling); 
        }
    }

    const prodCountContainer = document.querySelector('#prodCountContainer');
    const prodCount = document.createElement('span');
    prodCount.setAttribute('id', 'prodCount');
    prodCount.setAttribute('class', 'prodCount');

    const totalProducts = JSON.parse(localStorage.getItem('productsOnPage')).length;

    if (!document.getElementById('shownProdCount')) {
        prodCountContainer.innerHTML = '';
        if (totalProducts == products.length){
            prodCount.innerHTML = `<span id='shownProdCount'>${totalProducts}</span> Total Chassis`;
        } else {
            prodCount.innerHTML = `<span id='shownProdCount'>${products.length}</span> Chassis`;
        }
        prodCountContainer.appendChild(prodCount);

    } else {
        const shownProdCountElement = document.getElementById('shownProdCount');
        const lastProdCount = parseInt(shownProdCountElement.textContent);
        const currProdCount = products.length;
        animateCount(lastProdCount, currProdCount, shownProdCountElement);
    }

}


function createProducts(products, pageSize, pageStart=0){ 

    document.getElementById("products-of-collection-container").innerHTML = '';
    if (localStorage.getItem("eppPartner") !== null){
       if (localStorage.getItem("eppSiteDiscount") == null || localStorage.getItem("eppSiteDiscount") == undefined){ 
        fetchAndSetPricing(localStorage.getItem("eppPartner"))
       }
    }
    if (products.length === 0){
       const noProductsContainer = document.createElement('div');
        noProductsContainer.setAttribute('id', 'noProductsContainer');
        noProductsContainer.setAttribute('class', 'noProductsContainer');
        noProductsContainer.innerHTML = 'No products match this filter set.';
        
        const resetButton = document.createElement('button');
        resetButton.setAttribute('id', 'resetButton');
        resetButton.setAttribute('class', 'resetFilters');
        resetButton.innerHTML = 'Reset Filters';
        resetButton.addEventListener('click', function(){ resetCTOFilters(); });
        noProductsContainer.appendChild(resetButton);
        document.getElementById("products-of-collection-container").appendChild(noProductsContainer);
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        return;
    }

    if (products.length < 5) {

            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        
    }

      var sortOptions = ["manual", "best-selling", "title-ascending", "title-descending", "price-ascending", "price-descending", "created-ascending", "created-descending"];

    if (!window.location.href.includes("sort_by") ){
        products.sort((a, b) => b.rank - a.rank);
        products = products.reverse();
    } 

    document.getElementById("products-of-collection-container").innerHTML = '';

    for (let i = parseInt(pageStart); i < products.length ; i++) {
        if (i <= parseInt(pageStart) + parseInt(pageSize) - 1){
            let product = products[i].productDetails;
            let collection = products[i].collection;
            try{
                document.getElementById("products-of-collection-container").appendChild(createProductCard(product, collection));
            } catch (error){
                console.log(error);
            }
        }
    }

    setTimeout(function(){
        if (products.length > pageSize){
            createPaginationButtons(products, pageSize);
        } else {
            try{
            document.getElementById('pageNumberContainer').innerHTML = '';
            } catch (e) {
                console.log(e);
            }
        }
    }, 100);
    
    if (localStorage.getItem('ctoMinPrices') !== null){
        prices = JSON.parse(localStorage.getItem('ctoMinPrices'));
        for (const item in prices){
                var id ;
                if (prices[item]['sku'] !== 'null'){
                    id = prices[item]['sku'];
                }
              //  setStartingPrice(prices[item]['price'], id);
            }
            
    }
    productsOnPage = [];
    createProductCountButtons(products);


}

// Product Card

function swapToOgImage(imgElement) {
    const fullSrc = imgElement.getAttribute('data-second-full-src');
    const ogSrc = imgElement.getAttribute('data-og-src');
    if (!fullSrc.includes( 'no-image')){

    imgElement.src = ogSrc;
  }
  }
  function loadFullImage(imgElement) {
    const preSrc = imgElement.getAttribute('data-second-src');
    const fullSrc = imgElement.getAttribute('data-second-full-src');
    if (fullSrc === null) {
      return;
    }
    if (!fullSrc.includes( 'no-image')){

    const fullImage = new Image();
    imgElement.setAttribute('data-og-src', imgElement.getAttribute('src'));
    imgElement.style.imageRendering = 'pixelated';
    imgElement.src = preSrc;

    fullImage.src = fullSrc;
    fullImage.onload = function() {
      imgElement.style.imageRendering = 'auto';
      imgElement.src = fullSrc;
    };
  }
  }

document.addEventListener('scroll', function() {
    const filterBackground = document.getElementById('filterBackBackground');
    filterBackground.style.minHeight = '50px';
    
}); 


// Linked Resources



async function setupCTOContentResources(data) {
    var CTOContentResourcesContainer = document.querySelector('#CTOContentResourcesContainer');
    var resourceData = data;
    var resourceLink = resourceData.linkToResource;
    var resourceDescription = resourceData.description.content;

    var image = await fetchEntry("assets", resourceData.image.sys.id);
    var imageURL = image.fields.file.url.replace('//', 'https://');
    var imageDescription = image.fields.description;

    var parsedDescription = '';

    resourceDescription.forEach(node => {
        parsedDescription += parseRichText(node);
    });

    const resourceContainer = document.createElement('div');
    resourceContainer.classList.add('resourceContainer');

    const resourceImageContainer = document.createElement('div');
    resourceImageContainer.classList.add('resourceImageContainer');
    

    const resourceImage = document.createElement('img');
    resourceImage.src = imageURL + '?w=159';
    resourceImage.alt = imageDescription;
    resourceImage.classList.add('resourceImage');
    resourceImage.classList.add('lazyload');
    resourceImage.srcset = `
        ${imageURL}?w=159 159w,
        ${imageURL}?w=318 318w,
        ${imageURL}?w=300 480w,
        `;
    resourceImage.sizes = '(max-width: 159px) 159px, (max-width: 318px) 318px, (max-width: 480px) 480px';
    resourceImage.width = '159';
    resourceImage.height = '159';
    const resourceTitle = document.createElement('h3');
    resourceTitle.classList.add('resourceTitle');
    resourceTitle.innerHTML = resourceData.title;

    const resourceDescriptionContainer = document.createElement('div');
    resourceDescriptionContainer.classList.add('resourceDescriptionContainer');
    resourceDescriptionContainer.innerHTML = parsedDescription;

    const resourceLinkElem = document.createElement('a');
    resourceLinkElem.classList.add('resourceLink');
    resourceLinkElem.href = resourceLink;
    resourceLinkElem.title = resourceData.title;

    resourceImageContainer.appendChild(resourceImage);
    resourceLinkElem.appendChild(resourceImageContainer);
    resourceLinkElem.appendChild(resourceTitle);
    resourceLinkElem.appendChild(resourceDescriptionContainer);
    resourceContainer.appendChild(resourceLinkElem);
    CTOContentResourcesContainer.appendChild(resourceContainer);
}

async function setupCTOContentData(data) {
    title = data.fields.sectionTitle;
    sectionDescription = data.fields.sectionDescription.content;
    resourcesToDisplay = data.fields.resourcesToDisplay;
    let parsedDescription = '';

    sectionDescription.forEach(node => {
        parsedDescription += parseRichText(node);
    });

    fillTitleText(title, "#CTOContentTitle");
    fillDescriptionText(parsedDescription, "#CTOContentDescription");

    var entries = await retrieveLinkedEntries(resourcesToDisplay);
    for (const entry of entries) {
        await setupCTOContentResources(entry);
    }
    //await setupCTOContentResources(entries);
}

function fillSubtitleText(data) {
    subtitleContainer = document.querySelector('#collection_subtitle');
    subtitleContainer.innerHTML = data;
}

function getContentfulCTOFooter() {
    const spaceId = 'r8ntwc7p992u';
    const accessToken = 'C_-9V7wqzxMRbmSgfL-8CKh5-MUboq-YQ2UOmB3WHnU';

    const contentful = `https://cdn.contentful.com/spaces/${spaceId}/entries?content_type=ctoSelectionContent`;
    const headers = {
        Authorization: `Bearer ${accessToken}`
    };

    fetch(contentful, { headers })
    .then(response => response.json())
    .then(data => {
        const items = data.items;
        const lastItem = items[0];
        setupCTOContentData(lastItem);
    })
    .catch(error => {
        console.error('Error fetching data:', error);
    });
}



  getContentfulCTOFooter();

  document.getElementById("collection-filter").addEventListener('scroll', function() {
    const filterBackground = document.getElementById('filterBackBackground');
    const filterBack = document.querySelector('.filterBack');
    if (this.scrollTop > 10) {
        filterBackground.classList.remove('filterBackgroundHidden');
        filterBack.style.top = '0px';
        filterBackground.style.top = '-10px';
    } else {
        filterBackground.classList.add('filterBackgroundHidden');
        filterBack.style.top = '0px';
    }
});

function setStartingPrice(price, handle){
    if (window.location.href.includes('sort_by=price-ascending') || window.location.href.includes('sort_by=price-descending')) {
        try{
            if (price === undefined || handle === undefined) return;
            if (price === 0) return;

            if (handle.includes('-')){
            var priceElement = document.querySelector('.price-' + handle.replaceAll('-', '_') );
            }
            else {
                var priceElement = document.querySelector('.price-' + handle);
            }

            if (priceElement){
                priceElement.innerHTML = priceElement.innerHTML.replaceAll('Starting at:', "Chassis Price:");
            }
        } catch (e) {
            console.log(e);
        }
    } else {
        try{
            if (price === undefined || handle === undefined){
                return;
            }
            if (price === 0){
                return;
            }
            if (handle.includes('-')){
            var priceElement = document.querySelector('.price-' + handle.replaceAll('-', '_') );
            }
            else {
                var priceElement = document.querySelector('.price-' + handle);
            }

            if (priceElement){
                let formattedPrice = parseFloat(price).toLocaleString('en-US', {style: "currency", currency: "USD"});
                priceElement.innerHTML = formattedPrice;
                // "Starting at: " + formattedPrice;
            }
        } catch (e) {
            console.log(e);
        }
    }
}

async function fetchStartingPrices() {
    const url = 'https://api.ombligo.com/getStartingPrice'; 

    try {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const responseData = await response.json();

        for (const item in responseData){
            var id ;
            if (responseData[item]['sku'] !== 'null'){
                id = responseData[item]['sku'];
            }
           // setStartingPrice(responseData[item]['price'], id);
            localStorage.setItem("ctoMinPrices", JSON.stringify(responseData));
            localStorage.setItem("ctoMinPricesDate", new Date().toISOString());

        }
        } catch (error) {
        console.error('Error fetching starting prices:', error);
        return { error: error.message };
    }
}


